<template>
    <v-dialog width="500px"
              :value="value"
              scrollable
              persistent>
        <v-card>
            <v-toolbar class="kbGold"
                       dark
                       dense
                       flat
                       text>
                <div class="text-h6">
                    Cobro Manual
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="mt-2">
                <v-form lazy-validation
                        ref="formChargeTransactionAdmin"
                        :value="valid">
                    <v-row align="center">
                        <CompanyAppList :showManageButtons="false"
                                        :selectedCompany="selectedCompanyToCharge"
                                        :selectedApp="selectedAppToCharge"
                                        @input="selectApp($event)"/>

                        <v-spacer/>

                        <v-progress-circular color="kbDarkBlue"
                                             indeterminate
                                             v-if="loadingAppCreditCards">
                        </v-progress-circular>
                    </v-row>

                    <v-alert type="error"
                             :value="creditCards.length === 0"
                             style="border: none; border-radius: 12px">
                        La compañía seleccionada no tiene tarjetas de crédito asociadas.
                    </v-alert>

                    <template v-if="creditCards.length !== 0">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete :items="creditCards"
                                                color="kbDarkBlue"
                                                v-model="newCharge.creditCard"
                                                label="Tarjeta de crédito"
                                                no-data-text="No hay tarjetas"
                                                item-text="brand"
                                                item-value="cardId"
                                                prepend-icon="mdi-credit-card-settings"
                                                :menu-props="{maxHeight: 200}"
                                                :rules="[rules.required]"
                                                deletable-chips
                                                chips
                                                dense
                                                return-object>
                                    <template v-slot:item="data">
                                        <v-list-item-avatar>
                                            <img :src="require(`@/assets/credit_cards_material_design/png/48/${getImageFileName(data.item.brand)}.png`)">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{data.item.brand}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                *******{{data.item.last4Digits}}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="data">
                                        <PaymentCreditCardChip  :key="JSON.stringify(data.item.id)"
                                                                :brand="data.item.brand"
                                                                :label="data.item.brand"
                                                                :last4Digits="data.item.last4Digits"
                                                                close small selected
                                                                @input="newCharge.creditCard = null">
                                        </PaymentCreditCardChip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model.number="newCharge.ammount"
                                              color="kbDarkBlue"
                                              placeholder="0"
                                              label="Cantidad"
                                              style="font-size: 13px"
                                              type="number"
                                              prefix="USD"
                                              :rules="[rules.required]"
                                              @keyup.enter="submitDeposit">
                                    <v-row class="fill-height"  align="center" slot="prepend">
                                        <v-icon>mdi-currency-usd</v-icon>
                                    </v-row>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                       class="mr-2"
                       outlined
                       @click="toggleModal()">
                    Cerrar
                </v-btn>

                <v-btn color="kbGold"
                       dark
                       :disabled="loadingAppCreditCards || creditCards.length === 0"
                       @click="submit()"
                       :loading="loading">
                    Realizar Pago
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import bankBrandImages from '@/libs/bankBrandImages'
import CompanyAppList from '@/components/widgets/list/CompanyAppList.vue'
import rules from '@/libs/rules'
import PaymentCreditCardChip from '@/components/ui/PaymentCreditCardChip.vue'
import validations from '@/libs/validations'
export default {
  components: { CompanyAppList, PaymentCreditCardChip },
  data: () => ({
    creditCards: [],
    getImageFileName: bankBrandImages.getImageFileName,
    loading: false,
    loadingAppCreditCards: false,
    newCharge: {
      creditCard: null,
      ammount: ''
    },
    rules,
    selectedAppToCharge: {},
    selectedCompanyToCharge: {},
    valid: true
  }),
  methods: {
    async submit () {
      try {
        if (!this.$refs.formChargeTransactionAdmin.validate()) return

        if (!validations.minimumAmount(this.newCharge.ammount, 10)) return
        this.loading = true

        const data = {
          accountToCharge: 'otherAccount',
          amount: this.newCharge.ammount,
          cardId: this.newCharge.creditCard.cardId,
          companyId: this.selectedCompanyToCharge.UUID
        }

        await this.$store.dispatch('newPayment', data)
        this.loading = false
        this.toggleModal()
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    async getListCreditCards () {
      try {
        this.loadingAppCreditCards = true
        this.creditCards = await this.$store.dispatch('getListCreditCardsOfCompany', {
          companyUuid: this.selectedCompanyToCharge.UUID
        })
        this.loadingAppCreditCards = false
      } catch (e) {
        console.error(e)
        this.loadingAppCreditCards = false
      }
    },
    selectApp (app) {
      this.selectedAppToCharge = app
      this.selectedCompanyToCharge = app.company
      this.getListCreditCards()
    },
    toggleModal () {
      this.$refs.formChargeTransactionAdmin.reset()
      this.$emit('input', false)
    }
  },
  mounted () {
    this.selectedCompanyToCharge = this.$store.state.companies.selectedCompany
    this.selectedAppToCharge = this.$store.state.apps.selectedApp
    this.getListCreditCards()
  },
  props: ['value']
}
</script>
